import client from './client';

export type ModbusLiveDevice = { id:number; name:string; brand:string; model:string; serial:string; unit:number };
export type ModbusLiveMetric = { key:string; label:string; address:number; type:string; unit:string; value:number|string|null; raw:string; status:string; measuredAt:string };
export type ModbusLiveResult = { status:string; message:string; rows:ModbusLiveMetric[]; measuredAt:string };

export async function fetchModbusLiveDevices(uuid:string,signal?:AbortSignal) {
  const response=await client.get<{plantName:string;devices:ModbusLiveDevice[]}>(`/powerplants/${uuid}/modbus-live`,{signal,timeout:20000});
  return response.data;
}

export async function fetchModbusLiveValues(uuid:string,deviceId:number,signal?:AbortSignal) {
  const response=await client.get<ModbusLiveResult>(`/powerplants/${uuid}/modbus-live`,{params:{deviceId},signal,timeout:25000});
  return response.data;
}
